<template>
  <div class="content_box risk">
    <!-- 工具栏 插槽-->
    <div class="header" style="background: #1290c9">
      <Header @onSearch="onSearch" :themeColor="'#1290C9'">
        <!-- 工具栏 -->
        <Tollbar
          class="header_menu_box"
          :list="tollbarList"
          :sortList="sortList"
          :conditionsList="conditionsList"
          :selectList="selectList"
          :isShowExport="false"
          type="1"
          theme="1"
          :isShowSearch.sync="isShowSearch"
          :isShowSelect.sync="isShowSelect"
          @onClearSearch="clearParams"
          @onChangeSort="onChangeSort"
          @onExport="onExport"
        ></Tollbar>
      </Header>
    </div>
    <div class="content_wrap">
      <div class="wrap_search_box" v-show="isShowSearch">
        <el-collapse v-model="openMenu" ref="collapseItem">
          <el-collapse-item title="Legal Risk" name="0" class="first_item">
            <template slot="title">
              <span>{{ $t("RiskScan.CompanyName") }}</span>
              <span class="clear_all" @click.stop="clearParams">
                <i class="iconfont icon-qingchu" />{{ $t("RiskScan.ClearAll") }}
              </span>
            </template>

            <el-select
              clearable
              v-model="searchParams.companyName"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('RiskScan.Entercompanyname')"
              @change="(val) => onChangeParams(val, 'companyName')"
            >
              <el-option
                v-for="(item, index) in companyNameList"
                :key="index"
                :label="item.desc"
                :value="item.label"
              >
                <div class="flex-between-center">
                  <span class="select-name">{{ item.desc }}</span>
                </div>
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.ScanTime')" name="1">
            <el-date-picker
              class="widthFull"
              @change="filterDay"
              v-model="searchParams.scanTime"
              type="daterange"
              prefix-icon="iconfont icon-rili"
              range-separator=""
              :start-placeholder="$t('RiskScan.StartDate')"
              :end-placeholder="$t('RiskScan.EndDate')"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.UpdateStatus')" name="2">
            <el-checkbox-group
              v-model="searchParams.updateStatus"
              @change="handleChange"
            >
              <el-checkbox label="1" value="No Updates">{{
                $t("RiskScan.Notupdated")
              }}</el-checkbox>
              <el-checkbox label="2" value="Updating">{{
                $t("RiskScan.Updating")
              }}</el-checkbox>
              <el-checkbox label="3" value="Updated">{{
                $t("RiskScan.Updated")
              }}</el-checkbox>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.LegalRisk')" name="3">
            <el-select
              clearable
              multiple
              v-model="searchParams.legalRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('RiskScan.SelectRiskValue')"
              @change="(val) => onChangeParams(val, 'legalRisk')"
            >
              <el-option
                v-for="(item, index) in legalRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.OrganizationalRisk')" name="4">
            <el-select
              clearable
              multiple
              v-model="searchParams.organizationalRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('RiskScan.SelectRiskValue')"
              @change="(val) => onChangeParams(val, 'organizationalRisk')"
            >
              <el-option
                v-for="(item, index) in organizationalRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.OperationalRisk')" name="5">
            <el-select
              clearable
              multiple
              v-model="searchParams.operationalRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('RiskScan.SelectRiskValue')"
              @change="(val) => onChangeParams(val, 'operationalRisk')"
            >
              <el-option
                v-for="(item, index) in operationalRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.FinancialRisk')" name="6">
            <el-select
              clearable
              multiple
              v-model="searchParams.financialRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('RiskScan.SelectRiskValue')"
              @change="(val) => onChangeParams(val, 'financialRisk')"
            >
              <el-option
                v-for="(item, index) in financialRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.CreditRisk')" name="7">
            <el-select
              clearable
              multiple
              v-model="searchParams.creditRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('RiskScan.SelectRiskValue')"
              @change="(val) => onChangeParams(val, 'creditRisk')"
            >
              <el-option
                v-for="(item, index) in creditRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.ComplianceRisk')" name="8">
            <el-select
              clearable
              multiple
              v-model="searchParams.complianceRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('RiskScan.SelectRiskValue')"
              @change="(val) => onChangeParams(val, 'complianceRisk')"
            >
              <el-option
                v-for="(item, index) in complianceRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.SustainabilityRisk')" name="9">
            <el-select
              clearable
              multiple
              v-model="searchParams.sustainabilityRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('RiskScan.SelectRiskValue')"
              @change="(val) => onChangeParams(val, 'sustainabilityRisk')"
            >
              <el-option
                v-for="(item, index) in sustainabilityRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.IndustryRisk')" name="10">
            <el-select
              clearable
              multiple
              v-model="searchParams.industryRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('RiskScan.SelectRiskValue')"
              @change="(val) => onChangeParams(val, 'industryRisk')"
            >
              <el-option
                v-for="(item, index) in industryRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div class="wrap_con_box">
        <div class="table_header">
          <div class="table_header_title">
            {{ $t("RiskScan.HistoricalData") }}
          </div>
          <div class="table_header_menus">
            <el-button
              type="text"
              @click="RescanCheckBook"
              :disabled="!(isShowSelect && selectList.length > 0)"
              >{{ $t("RiskScan.Rescan") }}</el-button
            >
            <el-button type="text" @click="reSelect">{{
              $t("RiskScan.ReSelectData")
            }}</el-button>
            <el-button type="text" disabled>{{
              $t("RiskScan.DiagnosticReport")
            }}</el-button>
            <el-button
              type="text"
              @click="linkToLeads"
              :disabled="!(selectList.length == 1 && isShowSelect)"
              >{{ $t("RiskScan.SearchLeads") }}</el-button
            >
          </div>
        </div>
        <el-table
          class="risk_table"
          :data="tableData"
          height="100%"
          ref="tableRef"
          :row-key="(row) => row.id"
          @expand-change="onRowExpansion"
          :expand-row-keys="expandedRowKeys"
          @selection-change="onSelectionChange"
        >
          <el-table-column
            v-if="isShowSelect"
            :resizable="false"
            type="selection"
            reserve-selection
            align="center"
            class-name="table_check_row"
            width="40"
          />

          <el-table-column
            type="expand"
            align="center"
            width="25"
            :resizable="false"
          >
            <template slot-scope="scope">
              <div class="expand_table_box">
                <div class="flex_row">
                  <div class="expand_item">
                    <div
                      class="expand_item_title"
                      :style="{
                        color: showDot(scope.row.companyLegalRiskCode),
                      }"
                    >
                      {{ $t("RiskScan.LegalRisk") }}
                    </div>
                    <div class="expand_item_con_box">
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.CompanyID") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.companyId }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.CompanyType") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.companyTypeCodeDesc }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.RegistrationDate") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.regPeriod }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.RegistrationStatus") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.regCompanyStatusCodeDesc }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Listed") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.listed }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.LegalStatus") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.legalStatus }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="expand_item">
                    <div
                      class="expand_item_title"
                      :style="{
                        color: showDot(scope.row.companyOrgStructureRiskCode),
                      }"
                    >
                      {{ $t("RiskScan.OrganizationalRisk") }}
                    </div>
                    <div class="expand_item_con_box">
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.NoofShareholders") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.shareholders }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.ShareholdingLayers") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.shareholdingLayers }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.NoofCorporateShareholders") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.corporateShareholders }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.NoofNatualPersonShareholders") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.individualShareholders }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.RelatedCompanies") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.relatedCompanies }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.OrganizationalStatus") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.organizationalStatusEn }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="expand_item">
                    <div
                      class="expand_item_title"
                      :style="{
                        color: showDot(scope.row.companyOperatingRiskCode),
                      }"
                    >
                      {{ $t("RiskScan.OperationalRisk") }}
                    </div>
                    <div class="expand_item_con_box">
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.OperatingAddress") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.operatingAddress }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.IndustryCode") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.industryCode }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.BusinessActivities") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.businessActivities }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.NoofEmployees") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.employees }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Management") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.managementStatus }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.CurrentOperations") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.currentOperationsStatus }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="expand_item">
                    <div
                      class="expand_item_title"
                      :style="{
                        color: showDot(scope.row.companyFinancialRiskCode),
                      }"
                    >
                      {{ $t("RiskScan.FinancialRisk") }}
                    </div>
                    <div class="expand_item_con_box">
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Revenue") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.revenue }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Assests") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.assests }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.ProfitLoss") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.profitOrLoss }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Liquidity") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.liquidity }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Growth") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.growth }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Performance") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.performance }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex_row">
                  <div class="expand_item">
                    <div
                      class="expand_item_title"
                      :style="{
                        color: showDot(scope.row.companyCreditRiskCode),
                      }"
                    >
                      {{ $t("RiskScan.CreditRisk") }}
                    </div>
                    <div class="expand_item_con_box">
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.CreditRating") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.creditRating }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.CreditScore") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.creditScore }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.PausibilityofDefault") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.pd }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.SolvencyIndex") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.solvencyIndex }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.DebtCollection") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.debtCollection }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.CreditOpinion") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.riskIndex }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="expand_item">
                    <div
                      class="expand_item_title"
                      :style="{
                        color: showDot(scope.row.companyComplianceRiskCode),
                      }"
                    >
                      {{ $t("RiskScan.ComplianceRisk") }}
                    </div>
                    <div class="expand_item_con_box">
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.CompanySanction") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.companySanction }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.ProductSanction") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.productSanction }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.ExportControl") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.exportControl }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.AntiCorruptionAntiBribery") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.antiCorruptionAndBribery }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Litigations") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.litigations }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.NegativeNews") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.negativeNews }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="expand_item">
                    <div
                      class="expand_item_title"
                      :style="{
                        color: showDot(scope.row.companySustainabilityRiskCode),
                      }"
                    >
                      {{ $t("RiskScan.SustainabilityRisk") }}
                    </div>
                    <div class="expand_item_con_box">
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.ESGScore") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.ratingEsg }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.YearsinBusiness") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.yearsInBusiness }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Competitiveness") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.competitiveness }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.WorkingCapital") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.workingCapital }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.FinancialStructure") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.financialStructure }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.Industrystatus") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.growth }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="expand_item">
                    <div
                      class="expand_item_title"
                      :style="{
                        color: showDot(scope.row.companyIndustryRiskCode),
                      }"
                    >
                      {{ $t("RiskScan.IndustryRisk") }}
                    </div>
                    <div class="expand_item_con_box">
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.IndustryOutlook") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.industryForecast }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.NoofCompanies") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.companiesOfIndustry }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.IndustryRanking") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.industryPosition }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.IndustryConcentration") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.industryCentralization }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.IndustryCompetitiveness") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.industryCompetition }}
                        </div>
                      </div>
                      <div class="expand_item_list">
                        <div class="expand_item_list_label">
                          {{ $t("RiskScan.IndustryDevelopment") }}
                        </div>
                        <div class="expand_item_list_value">
                          {{ scope.row.industryDevelopment }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="companyName"
            :label="$t('RiskScan.CompanyName')"
            min-width="230"
          >
            <template slot-scope="scope">
              <!-- <span
                :class="!!scope.row.aaaId ? 'link_text hover_text' : ''"
                @click="!!scope.row.aaaId ? onGoPage(scope.row) : ''"
                >{{ scope.row.entname }}</span
              > -->
              <span
                class="link_text"
                @click="!!scope.row.aaaId ? onGoPage(scope.row) : ''"
                >{{ scope.row.companyName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            :label="$t('RiskScan.ScanTime')"
            min-width="115"
          >
            <template slot-scope="scope">
              <span>{{ formatDate(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="legalCode"
            align="center"
            :label="$t('RiskScan.Legal')"
            min-width="90"
          >
            <template slot-scope="scope">
              <div
                :style="{ background: showDot(scope.row.companyLegalRiskCode) }"
                class="table_cell_dot"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="organizationalCode"
            :label="$t('RiskScan.Organizational')"
            align="center"
            min-width="145"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  background: showDot(scope.row.companyOrgStructureRiskCode),
                }"
                class="table_cell_dot"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="operatingCode"
            align="center"
            :label="$t('RiskScan.Operational')"
            min-width="120"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  background: showDot(scope.row.companyOperatingRiskCode),
                }"
                class="table_cell_dot"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="financialCode"
            align="center"
            :label="$t('RiskScan.Financial')"
            min-width="100"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  background: showDot(scope.row.companyFinancialRiskCode),
                }"
                class="table_cell_dot"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="creditCode"
            align="center"
            :label="$t('RiskScan.Credit')"
            min-width="85"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  background: showDot(scope.row.companyCreditRiskCode),
                }"
                class="table_cell_dot"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="complianceCode"
            align="center"
            :label="$t('RiskScan.Compliance')"
            min-width="125"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  background: showDot(scope.row.companyComplianceRiskCode),
                }"
                class="table_cell_dot"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="sustainabilityCode"
            :label="$t('RiskScan.Sustainability')"
            align="center"
            min-width="150"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  background: showDot(scope.row.companySustainabilityRiskCode),
                }"
                class="table_cell_dot"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="industryCode"
            align="center"
            :label="$t('RiskScan.Industry')"
            min-width="95"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  background: showDot(scope.row.companyIndustryRiskCode),
                }"
                class="table_cell_dot"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="updateStatusEn"
            align="center"
            :label="$t('RiskScan.UpdateStatus')"
            min-width="130"
          >
          </el-table-column>
          <el-table-column align="center" label="" min-width="50">
            <template slot-scope="scope">
              <el-popover
                popper-class="table_popover"
                trigger="hover"
                effect="light"
                :content="$t('RiskScan.Download')"
                placement="top"
                :visible-arrow="false"
              >
                <i
                  slot="reference"
                  class="iconfont icon-xiazai"
                  @click="exportReport(scope.row.aaaId)"
                ></i>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <Page
            keyword="xxxx"
            :fontColor="'#1290C9'"
            :total="total"
            :pageSize="searchParams.pageSize"
            :currentPage="searchParams.currentPage"
            @onPageChange="onChangePage"
          ></Page>
        </div>
      </div>
    </div>
    <!-- 风险扫描操作弹窗 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="riskScanDialogOptionVisible"
      :before-close="
        () => {
          riskScanDialogOptionVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_800"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/risk_down_icon.png" />
        </div>
        <div class="risk_options_box">
          <div class="risk_list">
            <div class="risk_list_text">
              1. {{ $t("RiskScan.AddcompaniesfromSearchResult") }}
            </div>
            <el-button
              class="risk_chosen_btn"
              type="primary"
              @click="
                $router.push({
                  path: '/home',
                })
              "
              >{{ $t("RiskScan.Choose") }}
            </el-button>
          </div>
          <div class="risk_list">
            <div class="risk_list_text">
              2. {{ $t("RiskScan.AddcompaniesfromMyDatabase") }}
            </div>
            <el-button
              class="risk_chosen_btn"
              @click="
                $router.push({
                  path: '/account/companiesViewed?type=1',
                })
              "
            >
              <i class="iconfont icon-queren" />{{ $t("RiskScan.Choose") }}
            </el-button>
          </div>
          <div class="risk_list">
            <div class="risk_list_text">
              3. {{ $t("RiskScan.Addcompaniesbyuploadmyownlist") }}
            </div>
            <el-button class="risk_chosen_btn" @click="openUpload"
              >{{ $t("RiskScan.Upload") }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 上传 -->
    <UpdateFile
      :isUploaded="true"
      :UpdateFileDialog="UpdateFileDialog"
      @closeUpDownDialog="onCloseUpDownDialog"
      @uploadSuccess="onUploadSuccess"
    ></UpdateFile>
    <!-- 提示选择多少条 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="riskScanDialogVisible2"
      :before-close="
        () => {
          riskScanDialogVisible2 = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_550"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/risk_search_icon.png" />
        </div>
        <div class="dialog_title_img_text">
          {{ $t("RiskScan.RiskScanning") }}
        </div>
        <div class="risk_text">
          {{ $t("RiskScan.Youhaveselectedatotalof") }}
          <span class="num">{{ riskScanDialogLength }}</span>
          {{ $t("RiskScan.Tostartriskscanning") }}
        </div>
      </div>

      <div slot="footer" class="dialog_footer">
        <el-button
          @click="riskScanDialogVisible2 = false"
          class="risk_cancel_btn"
          type="cancel"
          >{{ $t("RiskScan.Cancel") }}</el-button
        >
        <el-button
          @click="confirmSanCheck"
          class="risk_primary_btn"
          type="primary"
          >{{ $t("RiskScan.Confirm") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { json } from "d3";
import tools from "@/views/layout/tools.vue";
import Page from "@/views/newLayout/page.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import Header from "@/views/newLayout/header.vue";
import UpdateFile from "../myAccount/Database/adCppany/UpdateFile.vue";
import { searchData, exportReport, filterConditions } from "@/api/companyApi";
import { downloadOnlinePdf } from "@/api/userApi";

export default {
  name: "RiskScanningHistory",
  data() {
    return {
      loadingVisible: false,
      loadingNum: 0,
      riskScanDialogVisible2: false,
      riskScanDialogLength: 0,
      searchForm: {
        date: [],
      },
      tableData: [],
      total: 0,
      expandedRowKeys: [], // 当前展开的行的 key
      searchParams: {
        isHistory: 1,
        currentPage: 1,
        pageSize: 10,
        companyName: [],
        scanTime: [],
        updateStatus: [],
        legalRisk: [],
        organizationalRisk: [],
        operationalRisk: [],
        financialRisk: [],
        creditRisk: [],
        complianceRisk: [],
        sustainabilityRisk: [],
        industryRisk: [],
      },
      riskScanDialogOptionVisible: false,
      UpdateFileDialog: false,
      openMenu: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      UpdateDateList: [
        { label: "High", value: "high" },
        { label: "Medium", value: "medium" },
        { label: "Low", value: "low" },
      ],
      companyNameList: [],
      industryRiskList: [],
      sustainabilityRiskList: [],
      complianceRiskList: [],
      creditRiskList: [],
      financialRiskList: [],
      operationalRiskList: [],
      organizationalRiskList: [],
      legalRiskList: [],
      conditionsList: ["Company Name", "Country", "Record Source"],
      selectList: [],
      isShowSearch: true, //默认展示侧边检索
      isShowSelect: false, // 是否显示复选框
      // 模拟数据
      localData: {
        current: 1,
        pageSize: 10,
        total: 20,
        rows: [
          {
            aaaId: "1",
            entname: "测试公司1",
            reportYear: "2023",
            scanTime: "2025-12-32",
            updateStatus: "No updates",
            legalCode: "绿",
            legalCodeDetail: {
              CD: "130111-0006246",
              CT: "Public Company",
              RD: "1969/1/13",
              RS: "Active",
              L: "Yes",
              LS: "Good Standing",
            },
            organizationalCode: "绿",
            organizationalDetail: {
              NOS: "86",
              SL: "53",
              NOCS: "8",
              NOIS: "8",
              RC: "3",
              OS: "Normal",
            },
            operatingCode: "红",
            operatingDetail: {
              OA: "Verified",
              IC: "ISIC 2610",
              BA: "Manufacture of ...",
              NOE: "109074",
              M: "Average",
              CO: "Normal",
            },
            financialCode: "绿",
            financialDetail: {
              R: "USD 198,247,859 K",
              A: "USD 349,053,672 K",
              PL: "Profit",
              L: "Average",
              G: "Yes",
              P: "Average",
            },
            creditCode: "红",
            creditDetail: {
              CR: "A",
              CS: "87",
              PD: "n.a.",
              SI: "Fair",
              DC: "Clear",
              CO: "Low Risk",
            },
            complianceCode: "黄",
            complianceDetail: {
              CS: "Clear",
              PS: "Clear",
              EC: "n.a.",
              AC: "Clear",
              L: "n.a.",
              NN: "n.a.",
            },
            sustainabilityCode: "黄",
            sustainabilityDetail: {
              ER: "n.a.",
              YIB: "15",
              C: "Average",
              MR: "Average",
              SCI: "66",
              IS: "23",
            },
            industryCode: "绿",
            industryDetail: {
              IP: "good", //Industry prospects
              IS: "95", //Industry status
              TI: "172", //Total number of industry enterprises
              IC: "good", //Industry concentration
              ICO: "Competition is stable", //Industry competition
              ID: "Decline Phase", //Industry development
            },
          },
          {
            aaaId: "2",
            entname: "测试公司1",
            reportYear: "2023",
            scanTime: "2025-12-31",
            updateStatus: "updating",
            legalCode: "黄",
            legalCodeDetail: {},
            organizationalCode: "绿",
            organizationalDetail: {},
            operatingCode: "绿",
            operatingDetail: {},
            financialCode: "黄",
            financialDetail: {},
            creditCode: "红",
            creditDetail: {},
            complianceCode: "红",
            complianceDetail: {},
            sustainabilityCode: "绿",
            sustainabilityDetail: {},
            industryCode: "绿",
            industryDetail: {},
          },
          {
            aaaId: "3",
            entname: "测试公司3",
            reportYear: "2023",
            scanTime: "2025-12-31",
            updateStatus: "updating",
            legalCode: "黄",
            legalCodeDetail: {},
            organizationalCode: "绿",
            organizationalDetail: {},
            operatingCode: "绿",
            operatingDetail: {},
            financialCode: "黄",
            financialDetail: {},
            creditCode: "红",
            creditDetail: {},
            complianceCode: "红",
            complianceDetail: {},
            sustainabilityCode: "绿",
            sustainabilityDetail: {},
            industryCode: "绿",
            industryDetail: {},
          },
          {
            aaaId: "4",
            entname: "测试公司4",
            reportYear: "2023",
            scanTime: "2025-12-31",
            updateStatus: "updating",
            legalCode: "黄",
            legalCodeDetail: {},
            organizationalCode: "绿",
            organizationalDetail: {},
            operatingCode: "绿",
            operatingDetail: {},
            financialCode: "黄",
            financialDetail: {},
            creditCode: "红",
            creditDetail: {},
            complianceCode: "红",
            complianceDetail: {},
            sustainabilityCode: "绿",
            sustainabilityDetail: {},
            industryCode: "绿",
            industryDetail: {},
          },
          {
            aaaId: "5",
            entname: "测试公司5",
            reportYear: "2023",
            scanTime: "2025-12-31",
            updateStatus: "updating",
            legalCode: "黄",
            legalCodeDetail: {},
            organizationalCode: "绿",
            organizationalDetail: {},
            operatingCode: "绿",
            operatingDetail: {},
            financialCode: "黄",
            financialDetail: {},
            creditCode: "红",
            creditDetail: {},
            complianceCode: "红",
            complianceDetail: {},
            sustainabilityCode: "绿",
            sustainabilityDetail: {},
            industryCode: "绿",
            industryDetail: {},
          },
          {
            aaaId: "6",
            entname: "测试公司6",
            reportYear: "2023",
            scanTime: "2025-12-31",
            updateStatus: "updating",
            legalCode: "黄",
            legalCodeDetail: {},
            organizationalCode: "绿",
            organizationalDetail: {},
            operatingCode: "绿",
            operatingDetail: {},
            financialCode: "黄",
            financialDetail: {},
            creditCode: "红",
            creditDetail: {},
            complianceCode: "红",
            complianceDetail: {},
            sustainabilityCode: "绿",
            sustainabilityDetail: {},
            industryCode: "绿",
            industryDetail: {},
          },
          {
            aaaId: "7",
            entname: "测试公司7",
            reportYear: "2023",
            scanTime: "2025-12-31",
            updateStatus: "updating",
            legalCode: "黄",
            legalCodeDetail: {},
            organizationalCode: "绿",
            organizationalDetail: {},
            operatingCode: "绿",
            operatingDetail: {},
            financialCode: "黄",
            financialDetail: {},
            creditCode: "红",
            creditDetail: {},
            complianceCode: "红",
            complianceDetail: {},
            sustainabilityCode: "绿",
            sustainabilityDetail: {},
            industryCode: "绿",
            industryDetail: {},
          },
          {
            aaaId: "8",
            entname: "测试公司8",
            reportYear: "2023",
            scanTime: "2025-12-31",
            updateStatus: "updating",
            legalCode: "黄",
            legalCodeDetail: {},
            organizationalCode: "绿",
            organizationalDetail: {},
            operatingCode: "绿",
            operatingDetail: {},
            financialCode: "黄",
            financialDetail: {},
            creditCode: "红",
            creditDetail: {},
            complianceCode: "红",
            complianceDetail: {},
            sustainabilityCode: "绿",
            sustainabilityDetail: {},
            industryCode: "绿",
            industryDetail: {},
          },
          {
            aaaId: "9",
            entname: "测试公司9",
            reportYear: "2023",
            scanTime: "2025-12-31",
            updateStatus: "updating",
            legalCode: "黄",
            legalCodeDetail: {},
            organizationalCode: "绿",
            organizationalDetail: {},
            operatingCode: "绿",
            operatingDetail: {},
            financialCode: "黄",
            financialDetail: {},
            creditCode: "红",
            creditDetail: {},
            complianceCode: "红",
            complianceDetail: {},
            sustainabilityCode: "绿",
            sustainabilityDetail: {},
            industryCode: "绿",
            industryDetail: {},
          },
          {
            aaaId: "10",
            entname: "测试公司10",
            reportYear: "2023",
            scanTime: "2025-12-31",
            updateStatus: "updating",
            legalCode: "黄",
            legalCodeDetail: {},
            organizationalCode: "绿",
            organizationalDetail: {},
            operatingCode: "绿",
            operatingDetail: {},
            financialCode: "黄",
            financialDetail: {},
            creditCode: "红",
            creditDetail: {},
            complianceCode: "红",
            complianceDetail: {},
            sustainabilityCode: "绿",
            sustainabilityDetail: {},
            industryCode: "绿",
            industryDetail: {},
          },
        ],
      },
    };
  },
  components: {
    Tollbar,
    tools,
    Page,
    Header,
    UpdateFile,
  },
  computed: {
    tollbarList() {
      return [
        {
          icon: "icon-xuanze",
          name: this.$t("Toolbar.Select"),
          disabled: false,
        },
        {
          icon: "icon-bianji1",
          name: this.$t("Toolbar.Edit"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: this.$t("Toolbar.Sortby"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: this.$t("Toolbar.Collect"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: this.$t("Toolbar.Saved"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: this.$t("Toolbar.Compare"),
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: this.$t("Toolbar.Export"),
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: this.$t("Toolbar.Download"),
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: this.$t("Toolbar.Update"),
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: this.$t("Toolbar.Reporterror"),
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: this.$t("Toolbar.Share"),
          disabled: true,
        },
      ];
    },

    sortList() {
      return [
        {
          value: "",
          label: "Default",
        },
        {
          value: "1",
          label: this.$t("Toolbar.ascending"),
        },
        {
          value: "2",
          label: this.$t("Toolbar.descending"),
        },
      ];
    },
    showDot() {
      return (value) => {
        if (value === "1") {
          return "#3fb92f";
        } else if (value === "2") {
          return "#ff8200";
        } else if (value === "3") {
          return "#ec1a1a";
        } else {
          return "#999999";
        }
      };
    },
    showDotText() {
      return (value) => {
        if (value === "1") {
          return "Good";
        } else if (value === "2") {
          return "General";
        } else if (value === "3") {
          return "Differ";
        } else {
          return "Not Evaluated";
        }
      };
    },
  },
  watch: {
    isShowSelect(val) {
      if (!val) {
        this.tollbarList.forEach((item) => {
          if (item.name == "Export") {
            item.disabled = true;
          }
        });
      } else {
        if (this.selectList.length > 0) {
          this.tollbarList.forEach((item) => {
            if (item.name == "Export") {
              item.disabled = false;
            }
          });
        }
      }
    },
  },
  methods: {
    formatDate(dateString) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(dateString).toLocaleDateString("en-CA", options);
    },
    formatDateToMDY() {
      const now = new Date();
      const month = (now.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始，需要+1
      const day = now.getDate().toString().padStart(2, "0");
      const year = now.getFullYear();
      return `${month}${day}${year}`;
    },
    // 工具栏点击
    onSearch(params) {},
    // 清空排序
    onChangeSort(e) {},
    // 清空
    clearParams() {
      this.searchParams = {
        isHistory: 1,
        currentPage: 1,
        pageSize: 10,
        companyName: "",
        scanTime: [],
        updateStatus: [],
        legalRisk: [],
        organizationalRisk: [],
        operationalRisk: [],
        financialRisk: [],
        creditRisk: [],
        complianceRisk: [],
        sustainabilityRisk: [],
        industryRisk: [],
      };
      this.getPageList();
    },
    // 检索
    onChangeParams() {
      this.getPageList();
    },
    // 时间选择
    filterDay(value) {
      if (!value) {
        this.searchParams.scanTime = [];
      }
      this.getPageList();
    },
    // 跳转获客
    linkToLeads() {
      if (this.selectList.length < 1) {
        return;
      } else {
        let aaa_id = this.selectList[0].aaaId;
        let name_en = this.selectList[0].companyName;
        let country_code = this.selectList[0].countryCode;
        let routeData = this.$router.resolve({
          path: "/index/list/risk",
          query: {
            aaa_id: aaa_id,
            name_en: name_en,
            country_code: country_code,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    // 重新扫描
    linkToRisk() {
      if (this.selectList.length == 0) return;
      //跳转
      let aaaidList = [];
      this.selectList.map((item) => {
        aaaidList.push(item.aaaId);
      });
      let routeData = this.$router.resolve({
        path: "/riskScanning/index",
        query: { aaaids: aaaidList.join("@@") },
      });
      window.open(routeData.href, "_blank");
    },
    // 重选一批
    reSelect() {
      this.riskScanDialogOptionVisible = true;
    },
    //单选框
    handleChange(val) {
      if (this.searchParams.updateStatus.length > 0) {
        this.searchParams.updateStatus = [
          val[this.searchParams.updateStatus.length - 1],
        ];
      }
      this.getPageList();
    },
    //过滤条件
    filterConditions() {
      let params = {
        isHistory: 1,
        aaaId: this.searchParams.companyName,
        legalRisk: this.searchParams.legalRisk,
        organizationalRisk: this.searchParams.organizationalRisk,
        operationalRisk: this.searchParams.operationalRisk,
        financialRisk: this.searchParams.financialRisk,
        creditRisk: this.searchParams.creditRisk,
        complianceRisk: this.searchParams.complianceRisk,
        sustaninabilityRisk: this.searchParams.sustainabilityRisk,
        industryRisk: this.searchParams.industryRisk,
        startTime: this.searchParams.scanTime
          ? this.searchParams.scanTime[0]
          : "",
        endTime: this.searchParams.scanTime
          ? this.searchParams.scanTime[1]
          : "",
        updateFlag: this.searchParams.updateStatus[0],
      };
      filterConditions(params)
        .then((res) => {
          if (res && res.code) {
            this.companyNameList = res.data.companyNameFilters;
            this.industryRiskList = res.data.industryRisk;
            this.sustainabilityRiskList = res.data.sustainabilityRisk;
            this.complianceRiskList = res.data.complianceRisk;
            this.creditRiskList = res.data.creditRisk;
            this.financialRiskList = res.data.financialRisk;
            this.operationalRiskList = res.data.operationalRisk;
            this.organizationalRiskList = res.data.organizationalRisk;
            this.legalRiskList = res.data.legalRisk;
          }
        })
        .catch((res) => {});
    },
    getPageList() {
      // 模拟获取数据的函数 searchData
      let aaaidList = [];
      if (this.searchParams.companyName != "") {
        aaaidList.push(this.searchParams.companyName);
      }

      const params = {
        isHistory: this.searchParams.isHistory,
        page: this.searchParams.currentPage,
        pageSize: this.searchParams.pageSize,
        startTime: this.searchParams.scanTime
          ? this.searchParams.scanTime[0]
          : "",
        endTime: this.searchParams.scanTime
          ? this.searchParams.scanTime[1]
          : "",
        // companyName:this.searchParams.companyName,
        aaaIds: aaaidList,
        legalRisk: this.searchParams.legalRisk,
        organizationalRisk: this.searchParams.organizationalRisk,
        operationalRisk: this.searchParams.operationalRisk,
        financialRisk: this.searchParams.financialRisk,
        creditRisk: this.searchParams.creditRisk,
        complianceRisk: this.searchParams.complianceRisk,
        sustaninabilityRisk: this.searchParams.sustainabilityRisk,
        industryRisk: this.searchParams.industryRisk,
        updateFlag: this.searchParams.updateStatus[0],
      };

      // 在这里调用API获取数据，并更新tableData和total
      searchData(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        })
        .catch((res) => {});
      this.filterConditions();
      // this.tableData = this.localData.rows;
      // this.total = this.localData.total;
    },
    //下载
    exportReport(id) {
      downloadOnlinePdf(id)
        .then((res) => {
          const binaryData = [];
          binaryData.push(res);
          let pdfUrl = window.URL.createObjectURL(
            new Blob(binaryData, { type: "application/pdf" }),
          );
          window.open(pdfUrl, "_blank");
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    // 导出
    onExport() {
      if (this.selectList.length == 0) return;
      const params = this.selectList.map((item) => {
        return item.id;
      });
      exportReport({
        ids: params,
        isHistory: 1,
      })
        .then((res) => {
          const blob = new Blob([res], { type: "application/vnd.ms-excel" });
          const fileName = "Risk Scan " + this.formatDateToMDY() + ".xlsx"; // 文件名 Risk Scan+01292026
          const href = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = href;
          link.download = fileName; // 设置下载文件名
          link.click();
        })
        .catch((res) => {});
    },
    // 表格展开
    onRowExpansion(row) {
      this.$emit("selectTwoRow", []); //展开时清空所有选择项
      // 如果展开的行已存在于 expandedRowKeys 数组中，则关闭所有行
      if (this.expandedRowKeys.includes(row.id)) {
        this.expandedRowKeys = [];
      } else {
        // 否则只展开当前行
        this.expandedRowKeys = [row.id];
      }
    },
    // 表格模式行选择改变时
    onSelectionChange(val) {
      this.selectList = val;
      if (val.length > 0 && this.isShowSelect) {
        this.tollbarList.forEach((item) => {
          if (item.name == "Export") {
            item.disabled = false;
          }
        });
      } else {
        this.tollbarList.forEach((item) => {
          if (item.name == "Export") {
            item.disabled = true;
          }
        });
      }
    },
    // 翻页
    onChangePage(pagParm) {
      this.searchParams.currentPage = pagParm.page;
      this.searchParams.pageSize = pagParm.pageSize;
      this.getPageList();
    },
    handleSearch() {
      this.currentPage = 1;
      this.getPageList();
    },
    resetSearch() {
      this.searchForm.scanTime = [];
      this.currentPage = 1;
      this.getPageList();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.getPageList();
    },
    // 打开上传
    openUpload() {
      this.riskScanDialogOptionVisible = false;
      this.UpdateFileDialog = true;
    },
    // 关闭上传
    onCloseUpDownDialog() {
      this.UpdateFileDialog = false;
    },
    // 上传确认后后跳转到我的数据
    onUploadSuccess() {
      this.$router.push({
        path: "/account/companiesViewed",
        query: {
          type: 4,
        },
      });
    },
    onGoPage(row) {
      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaaId +
          "/background/snapshot?id3a=" +
          row.aaaId +
          "&companyCountry=" +
          row.countryCode +
          // "&SACode1=" +
          // SACode1 +
          "&companyName=" +
          row.companyName +
          "&keword=" +
          this.$route.query.keword,
      });
      // let routeData = this.$router.resolve({
      //   path: "/sanction/companyDetail/sanction",
      //   query: {
      //     id3a: row.aaaid,
      //     id: row.id,
      //     keyword: this.$route.query.keyword,
      //     selectCode: 1,
      //   },
      // });
      window.open(routeData.href, "_blank");
    },
    //Rescan
    RescanCheckBook() {
      if (this.selectList.length == 0) return;
      this.riskScanDialogVisible2 = true;
      this.riskScanDialogLength = this.selectList.length;
    },
    //扫描确认
    confirmSanCheck() {
      this.riskScanDialogVisible2 = false;
      this.aaaidList = [];
      this.selectList.map((item) => {
        this.aaaidList.push(item.aaaId);
      });
      //跳转
      let routeData = this.$router.resolve({
        path: "/riskScanning/index",
        query: { aaaids: this.aaaidList.join("@@") },
      });
      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    this.getPageList();
    // this.filterConditions();
  },
};
</script>
<style></style>
<style scoped>
.loading_box {
  width: 286px;
  height: 286px;
  overflow: hidden;
  position: relative;
  margin-top: 30px;
  margin-bottom: 10px;
  background-image: url("../../assets/images/loadingOut_bg.png");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading_bg {
  margin: 0 auto;
  width: 192px;
  height: 192px;
  background-image: url("../../assets/images/loadingCon_bg.png");
  background-size: cover;
  background-position: center;
  animation: spin 3s linear infinite;
}
.loading_num {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 40px;
  color: #ffffff;
  line-height: 80px;
  text-align: center;
}

.risk_options_box {
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.risk_list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 30px 20px;
}
.risk_list_text {
  font-weight: bold;
  font-size: 24px;
  color: #1a2332;
  line-height: 40px;
  text-align: left;
}
.risk_chosen_btn {
  width: 120px;
  height: 40px;
  background: #1290c9;
  border-radius: 10px;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  padding: 0 !important;
  flex-shrink: 0;
}
@media (max-width: 1920px) {
  .risk_options_box {
    margin-top: 16px;
    gap: 16px;
  }
  .risk_list {
    height: 75px;
    padding: 22px 16px;
  }
  .risk_list_text {
    font-size: 18px;
    line-height: 30px;
  }
  .risk_chosen_btn {
    width: 100px;
    height: 32px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 30px;
  }
}
</style>
